var exports = {
  "zp": "LinkedAccountsTab.module__spinnerWrapper___ZU0wZW",
  "p$": "LinkedAccountsTab.module__emptyState___ZU0wZW",
  "G$": "LinkedAccountsTab.module__platformRow___ZU0wZW",
  "h5": "LinkedAccountsTab.module__platformIconButton___ZU0wZW",
  "eF": "LinkedAccountsTab.module__connectionsList___ZU0wZW",
  "Nr": "LinkedAccountsTab.module__card___ZU0wZW",
  "wy": "LinkedAccountsTab.module__cardDragging___ZU0wZW",
  "V7": "LinkedAccountsTab.module__cardDragHandle___ZU0wZW",
  "EF": "LinkedAccountsTab.module__cardIconSquircle___ZU0wZW",
  "Bj": "LinkedAccountsTab.module__cardInfo___ZU0wZW",
  "_O": "LinkedAccountsTab.module__cardName___ZU0wZW",
  "SI": "LinkedAccountsTab.module__cardNameRow___ZU0wZW",
  "vN": "LinkedAccountsTab.module__verificationBadge___ZU0wZW",
  "eB": "LinkedAccountsTab.module__cardActions___ZU0wZW",
  "hP": "LinkedAccountsTab.module__actionButton___ZU0wZW",
  "Il": "LinkedAccountsTab.module__dropIndicatorTop___ZU0wZW",
  "Yc": "LinkedAccountsTab.module__dropIndicatorBottom___ZU0wZW",
};

module.exports = exports;
